import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CSVLink } from 'react-csv';
import download from '../../../assets/img/download.svg';
import { getApiResponseData } from '../../../services/apiservices';
import { getPostResponseAPIData } from '../../../services/apiservices';
import { ButtonStyle } from './RiskFilterButtonStyle';
import { withRouter } from 'react-router-dom';
import Spinner from '@material-ui/core/CircularProgress';
import { showLoader } from '../../../slices/RiskFilterSlice';
import styled from 'styled-components';
const StyledSpan = styled.span`
  margin-top: 1px !important;
  color: '#212121';
`;

const ExportToExcel = props => {
  const dispatch = useDispatch();
  const [results, setResults] = useState([]);
  const csvLinkEl = useRef();
  const tabFlag = useSelector(state => state.buttonSlice.tabFlag);
  const apiResponseData = useSelector(state => state.recommendationTable.exportCSV);
  const [exportStatus, setExportStatus] = React.useState(false);
  const envClickEvent = useSelector(state => state.applicationDrillHeatMap.envClickEvent);
  const applyEvent = useSelector(state => state.riskFilterSlice.applyEvent);
  const loader = useSelector(state => state.riskFilterSlice.isLoader);
  const selectedApplication = useSelector(state => state.heatMapSlice.selectedApplication);
  const selectedAccount = useSelector(state => state.applicationDrillHeatMap.selectedAccount);

  const getResults = (apiUrl, apiRequestBody, totalCount) => {
    dispatch(showLoader(true));
    var urlArray = apiUrl.split('?');
    let urlQueryArray = [];

    if (urlArray) {
      urlQueryArray = urlArray[1]?.split('&');
    }

    let totalElements;
    let sort;
    let view = '';
    let filter;
    let origin;

    if (urlQueryArray) {
      for (var i = 0; i < urlQueryArray.length; i++) {
        var pair = urlQueryArray[i].split('=');

        if (pair[0] === 'limit') {
          totalElements = totalCount;
        } else if (pair[0] === 'sortBy') {
          sort = urlQueryArray[i];
        } else if (pair[0] === 'view') {
          view = '&' + urlQueryArray[i];
        } else if (pair[0] === 'filter') {
          filter = urlQueryArray[i];
        } else if (pair[0] === 'origin') {
          origin = urlQueryArray[i];
        }
      }
    }

    let baseUrl = '';

    if (applyEvent) {
      baseUrl = urlArray[0];
      let resultObj = {};
      let objKeys = Object.keys(apiRequestBody);

      for (var j = 0; j < objKeys.length; j++) {
        if (objKeys[j] === 'fieldList') {
          resultObj['fieldList'] = apiRequestBody['fieldList'];
        } else if (objKeys[j] === 'filter') {
          resultObj['filter'] = apiRequestBody['filter'];
        } else if (objKeys[j] === 'limit') {
          resultObj['limit'] = totalCount;
        } else if (objKeys[j] === 'objectType') {
          resultObj['objectType'] = apiRequestBody['objectType'];
        } else if (objKeys[j] === 'offset') {
          resultObj['offset'] = 0;
        } else if (objKeys[j] === 'origin') {
          resultObj['origin'] = apiRequestBody['origin'];
        } else if (objKeys[j] === 'recommendationOrImpact') {
          resultObj['recommendationOrImpact'] = apiRequestBody['recommendationOrImpact'];
        } else if (objKeys[j] === 'sortBy') {
          resultObj['sortBy'] = apiRequestBody['sortBy'];
        }
      }

      dispatch(getPostResponseAPIData(baseUrl, 'exportCSV', resultObj));
    } else {
      if (tabFlag && !selectedAccount) {
        if (origin) {
          baseUrl = urlArray[0] + '?' + `limit=${totalElements}` + `&offset=${0}` + '&' + sort + '&' + origin;
        } else if (selectedApplication) {
          baseUrl = urlArray[0] + '?' + filter + '&' + `limit=${totalElements}` + `&offset=${0}` + '&' + sort;
        } else {
          baseUrl = urlArray[0] + '?' + `limit=${totalElements}` + `&offset=${0}` + '&' + sort;
        }
      } else {
        if (filter) {
          baseUrl = urlArray[0] + '?' + filter + '&' + `limit=${totalElements}` + `&offset=${0}` + '&' + sort + view;
        } else {
          baseUrl = urlArray[0] + '?' + `limit=${totalElements}` + `&offset=${0}` + '&' + sort + view;
        }
      }

      if (envClickEvent || selectedAccount) {
        if (filter) {
          baseUrl = urlArray[0] + '?' + filter + '&' + `limit=${totalElements}` + `&offset=${0}` + '&' + sort + view;
        }
      }

      dispatch(getApiResponseData(baseUrl, 'exportCSV'));
    }

    setExportStatus(true);
  };

  useEffect(() => {
    let queryResults = {
      data: [],
      totalCount: 0,
      totalPages: 0
    };

    if (apiResponseData && !apiResponseData?.isLoading) {
      queryResults = apiResponseData.data.responseList;

      if (tabFlag && !selectedAccount) {
        if (selectedApplication && selectedApplication.length && !selectedAccount) {
          queryResults = queryResults.map(e => ({
            origin: e.origin,
            envName: e.envName,
            originRiskCategory: e.originRiskCategory,
            originRiskScore: e.originRiskScore,
            users: e.users,
            groups: e.groups,
            roles: e.roles,
            resources: e.resources
          }));
        } else {
          queryResults = queryResults.map(e => ({
            origin: e.origin,
            originRiskCategory: e.originRiskCategory,
            originRiskScore: e.originRiskScore,
            users: e.users,
            groups: e.groups,
            roles: e.roles,
            resources: e.resources
          }));
        }
      } else {
        queryResults = queryResults.map(e => ({
          appName: e.appName,
          appType: e.appType,
          originRiskCategory: e.originRiskCategory,
          originRiskScore: e.originRiskScore,
          envName: e.envName,
          accountRiskScore: e.accountRiskScore,
          accountRiskCategory: e.accountRiskCategory,
          objectArn: e.objectArn,
          objectName: e.objectName,
          objectType: e.objectType,
          entityRiskCategory: e.entityRiskCategory,
          entityRiskScore: e.entityRiskScore
        }));
      }

      setResults(queryResults);
    }

    return () => {
      setResults([]);
    };
  }, [apiResponseData]);
  useEffect(() => {
    if (!apiResponseData?.isLoading && exportStatus && results.length) {
      getCSVFile();
      setExportStatus(false);
    } else if (apiResponseData?.isLoading && !results.length) {
      dispatch(showLoader(false));
    }
  }, [apiResponseData, exportStatus, results]);

  const getCSVFile = () => {
    dispatch(showLoader(false));
    setTimeout(() => {
      let csvLink = csvLinkEl.current;

      if (csvLink != null) {
        csvLinkEl.current.link.click();
        setResults([]);
      }
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CSVLink, {
    data: results,
    filename: `${props.fileName}.csv`,
    target: "_blank",
    ref: csvLinkEl
  }), /*#__PURE__*/React.createElement(ButtonStyle, {
    startIcon: loader ? /*#__PURE__*/React.createElement(Spinner, {
      animation: "border",
      role: "status",
      size: 10,
      style: {
        marginRight: '8px',
        marginLeft: '5px'
      }
    }) : /*#__PURE__*/React.createElement("img", {
      alt: "download",
      src: download
    }),
    onClick: () => getResults(props.apiUrl, props.apiRequestBody, props.totalCount, props.fileName)
  }, /*#__PURE__*/React.createElement(StyledSpan, null, " Export")));
};

export default withRouter(ExportToExcel);